export default {
    props: {
        error: Boolean,
        title: String,
        type: String
    }
};



// WEBPACK FOOTER //
// ./src/components/RelatedInfo/RelatedInfo.js